import { useId, type InputHTMLAttributes } from "react";

interface FormFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string | undefined;
  help?: string | undefined;
}

export function FormField({ label, error, help, id: suppliedId, required, ...props }: FormFieldProps) {
  const generatedId = useId();
  const id = suppliedId ?? generatedId;
  const describedBy = [help ? `${id}-help` : null, error ? `${id}-error` : null].filter(Boolean).join(" ") || undefined;
  return (
    <div className="form-group">
      <label htmlFor={id}>{label}{required && <span aria-hidden="true" className="text-danger"> *</span>}</label>
      <input {...props} id={id} required={required} aria-invalid={Boolean(error)} aria-describedby={describedBy} className={`form-control ${error ? "is-invalid" : ""}`} />
      {help && <small id={`${id}-help`} className="form-text text-muted">{help}</small>}
      {error && <div id={`${id}-error`} className="invalid-feedback">{error}</div>}
    </div>
  );
}
